export default __webpack_public_path__ + "cuttingedge.mp3";